import { render, staticRenderFns } from "./ConfirmFinalize.vue?vue&type=template&id=134c8bd2&"
import script from "./ConfirmFinalize.vue?vue&type=script&lang=ts&"
export * from "./ConfirmFinalize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports